// Modules
import React from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'

// Styling
import './App.css'
import './animations.css'

// Components
import Home from './Components/Home/Home'
import UserPage from './Components/Account/UserPage'
import AddAcountInfo from './Components/Account/AddAccountInfo'

const App = () => {
  return (
    <Router className='App'>
      <Route exact path='/' component={Home} />
      <Route exact path='/login' component={Home} />
      <Route exact path='/signup' component={Home} />
      <Route exact path='/logged-in' component={UserPage} />
      <Route exact path='/add-account-info' component={AddAcountInfo} />
    </Router>
  )
}

export default App
